import axiosInstance from "./api_instance";

export const getAllTicketByEvent = (eventId) => {
  return axiosInstance.get(`client/events/${eventId}/ticket-types`);
};

export const getStatusStatisticTicketType = (eventId, ticketTypeId) => {
  return axiosInstance.get(
    `event-operator/tickets/statistic/status?eventId=${eventId}&ticketTypeId=${ticketTypeId}`
  );
};

export const getGenerateStatistic = (eventId) => {
  return axiosInstance.get(
    `event-operator/events/${eventId}/statistic/generate`
  );
};

export const getReservationStatistic = (eventId) => {
  return axiosInstance.get(
    `event-operator/events/${eventId}/statistic/reservation`
  );
};

export const getPaymentOptionStatistic = (eventId) => {
  return axiosInstance.get(
    `event-operator/events/${eventId}/statistic/paymentOption`
  );
};

export const getTicketStatusStatistic = (eventId) => {
  return axiosInstance.get(`event-operator/events/${eventId}/statistic/status`);
};
